/* eslint-disable react/prop-types */
import { Icon } from "@fluentui/react";
import ConstructionStatus from "../../../../../types/ConstructionStatus";
import styles from "./acceptedCell.module.scss";

interface AcceptedCellProps {
    constructionStatus: ConstructionStatus;
}

const AcceptedCell: React.FunctionComponent<AcceptedCellProps> = ({
    constructionStatus,
}) => {
    if (constructionStatus === ConstructionStatus.Accepted) {   
        return (
            <Icon
                iconName="CheckboxCompositeReversed"
                className={styles.constructionIsAccepted}
                title="Construction is accepted. No changes can be performed."
            />
        );
    } else {
        return (
            <Icon
            iconName="ConstructionConeSolid"
            className={styles.constructionIsActive}
            title="Construction is active"
            />
        );
    }
};
        
export default AcceptedCell;
